import i18next from 'i18next';
import i18nextXHRBackend from 'i18next-xhr-backend';
import abTranslate from 'ab-translate/dist/src/abTranslate-runtime';

export default function i18n({ locale, baseStaticsUrl = '', experiments }) {
  const namespaces = [
    `${baseStaticsUrl}assets/locale`,
    '//static.parastorage.com/services/locale-dataset-data/1.983.0/translations',
  ];
  return i18next
    .createInstance()
    .use(i18nextXHRBackend)
    .init({
      lng: locale,
      fallbackLng: 'en',
      keySeparator: '$',
      interpolation: {
        escapeValue: false,
      },
      ns: namespaces,
      defaultNS: namespaces[0],
      fallbackNS: namespaces.slice(1),
      backend: {
        loadPath: `{{ns}}/messages_{{lng}}.json`,
        crossDomain: true,
      },
      parse: (translations) => {
        try {
          return abTranslate(experiments, JSON.parse(translations));
        } catch (e) {
          return translations;
        }
      },
    });
}
